import * as types from '../types'
import VIEWS from '../views'

export const initialState = VIEWS.username

export default (state = initialState, { type }) => {
  switch (type) {
    case types.VIEW_NEXT:
      return Object.assign({}, state, VIEWS[state.next])
    case types.VIEW_BACK:
      return Object.assign({}, state, VIEWS[state.back])
    case types.VIEW_RESTART:
      return Object.assign({}, state, initialState)
    default:
      return state
  }
}
